import { SettingRow, SettingsGroup, Switch } from "@rhema/ui";
import { useState } from "react";
import { useApi } from "../session/session";
import { resultMessage } from "./NotificationPrompt";
import { setPrefs, useNotificationPrefs } from "./prefs";
import { browserPushEnv, disablePush, enablePush, type PushEnv } from "./push";

// The notification switches in Settings.
export function NotificationSettings({ env = browserPushEnv() }: { env?: PushEnv }) {
  const api = useApi();
  const prefs = useNotificationPrefs();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const supported = env.permission() !== "unsupported";
  const on = supported && prefs.enabled === true && env.permission() === "granted";

  const toggle = async (next: boolean) => {
    setBusy(true);
    setMessage(null);
    try {
      if (next) setMessage(resultMessage(await enablePush(api, env)));
      else await disablePush(api, env);
    } catch {
      setMessage(next ? "Notifications could not be turned on. Try again." : null);
    } finally {
      setBusy(false);
    }
  };

  return (
    <SettingsGroup>
      <SettingRow
        title="Notifications"
        detail={
          message ??
          (supported
            ? on
              ? "This browser tells you when a message arrives"
              : "Turn on to hear about new messages in this browser"
            : "This browser cannot show notifications")
        }
        trailing={
          <Switch
            label="Notifications"
            checked={on}
            disabled={!supported || busy}
            onChange={(next) => void toggle(next)}
          />
        }
      />
      <SettingRow
        title="Show message text in notifications"
        detail="Off by default. When it is off, a notification only says who wrote to you."
        trailing={
          <Switch
            label="Show message text in notifications"
            checked={prefs.showText}
            disabled={!on}
            onChange={(showText) => setPrefs({ showText })}
          />
        }
      />
    </SettingsGroup>
  );
}
